import { render, staticRenderFns } from "./TransactionsView.vue?vue&type=template&id=6478c784&scoped=true"
import script from "./TransactionsView.vue?vue&type=script&lang=ts"
export * from "./TransactionsView.vue?vue&type=script&lang=ts"
import style0 from "./TransactionsView.vue?vue&type=style&index=0&id=6478c784&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6478c784",
  null
  
)

export default component.exports